import { createContext, useContext } from "react";
import type { Location } from "react-router-dom";

/**
 * The "actual" browser URL location, exposed independently of any
 * `<Routes location={background}>` override used by the Signal modal
 * background-location pattern.
 *
 * AppRoutes provides this with the real `useLocation()` result so that
 * descendants rendered against the background location (e.g. <Signal />
 * mounted under "/" while the URL is "/signal/:slug") can still observe
 * the true URL and open the modal for the right post on direct hits,
 * back/forward, and shared deep links.
 */
export const ActualLocationContext = createContext<Location | null>(null);

export const useActualLocation = (): Location | null => useContext(ActualLocationContext);
